var _desc, _defs, _rect, _circle, _circle2, _path, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLibraryMarketCover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1500",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Community note marketplace") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "description"
  }, "Colorful study cards shared between learners")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "background",
    x1: 100,
    y1: 60,
    x2: 1090,
    y2: 1420,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#173f5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#1f7a75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed8f72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cardBlue",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9f4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b9d9ef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cardCream",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f3d8aa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cardCoral",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe6df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5ae9b"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "170%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 28,
    stdDeviation: 24,
    floodColor: "#092a3b",
    floodOpacity: 0.28
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 1500,
    fill: "url(#background)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1055,
    cy: 176,
    r: 235,
    fill: "#8bd0c9",
    opacity: 0.18
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 105,
    cy: 1240,
    r: 280,
    fill: "#ffd5a7",
    opacity: 0.13
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1160C235 1060 355 1175 580 1095C835 1005 945 1065 1200 935V1500H0Z",
    fill: "#0c2f45",
    opacity: 0.18
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.55,
    fill: "none",
    stroke: "#d4f5ee",
    strokeWidth: 10,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173 338C304 188 455 236 553 362"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651 324C787 176 947 218 1027 390"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270 890C420 1030 739 1015 914 855"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff3cf"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 340,
    r: 19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 552,
    cy: 362,
    r: 19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 651,
    cy: 324,
    r: 19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1027,
    cy: 390,
    r: 19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 890,
    r: 19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 914,
    cy: 855,
    r: 19
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(118 420) rotate(-8 285 360)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 570,
    height: 720,
    rx: 48,
    fill: "url(#cardBlue)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 112,
    r: 47,
    fill: "#2369a1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 100,
    r: 18,
    fill: "#d9eefc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74 148c11-35 61-35 72 0",
    fill: "#d9eefc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187,
    y: 79,
    width: 277,
    height: 24,
    rx: 12,
    fill: "#2369a1",
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187,
    y: 124,
    width: 190,
    height: 18,
    rx: 9,
    fill: "#548eb7",
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82 244h406M82 310h328M82 376h374M82 442h258",
    fill: "none",
    stroke: "#326e98",
    strokeWidth: 20,
    strokeLinecap: "round",
    opacity: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 542,
    width: 198,
    height: 92,
    rx: 46,
    fill: "#2369a1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127 589h108",
    stroke: "#e9f4ff",
    strokeWidth: 17,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 442,
    cy: 588,
    r: 48,
    fill: "#7bc7be"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m420 588 15 15 30-35",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(520 252) rotate(7 275 350)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 550,
    height: 700,
    rx: 48,
    fill: "url(#cardCream)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105,
    cy: 108,
    r: 45,
    fill: "#dd8068"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105,
    cy: 96,
    r: 17,
    fill: "#fff5e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 142c10-33 58-33 68 0",
    fill: "#fff5e4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 78,
    width: 282,
    height: 24,
    rx: 12,
    fill: "#9d604f",
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 123,
    width: 224,
    height: 18,
    rx: 9,
    fill: "#be8b70",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 220,
    width: 406,
    height: 180,
    rx: 34,
    fill: "#ffffff",
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127 279h294M127 332h218",
    stroke: "#a86d58",
    strokeWidth: 20,
    strokeLinecap: "round",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 491h352M90 555h286",
    stroke: "#b37a5b",
    strokeWidth: 20,
    strokeLinecap: "round",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 453,
    cy: 575,
    r: 48,
    fill: "#efaa68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430 576h46M453 553v46",
    stroke: "#fff",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(318 784) rotate(3 280 325)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 560,
    height: 650,
    rx: 48,
    fill: "url(#cardCoral)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105,
    cy: 108,
    r: 45,
    fill: "#4d8b80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105,
    cy: 96,
    r: 17,
    fill: "#e4f5ed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 142c10-33 58-33 68 0",
    fill: "#e4f5ed"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 78,
    width: 276,
    height: 24,
    rx: 12,
    fill: "#426f69",
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 123,
    width: 205,
    height: 18,
    rx: 9,
    fill: "#63978d",
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84 244h390M84 310h310M84 376h352",
    stroke: "#a35e57",
    strokeWidth: 20,
    strokeLinecap: "round",
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(84 464)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 125,
    height: 82,
    rx: 26,
    fill: "#ffffff",
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    width: 125,
    height: 82,
    rx: 26,
    fill: "#ffffff",
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    width: 125,
    height: 82,
    rx: 26,
    fill: "#ffffff",
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 41,
    r: 18,
    fill: "#4d8b80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 207,
    cy: 41,
    r: 18,
    fill: "#dd8068"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 352,
    cy: 41,
    r: 18,
    fill: "#2369a1"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff3cf",
    opacity: 0.88
  }, /*#__PURE__*/React.createElement("path", {
    d: "m134 178 15 40 42 15-42 15-15 40-15-40-42-15 42-15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1062 668 12 33 35 12-35 12-12 34-13-34-34-12 34-12Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 996,
    cy: 1055,
    r: 17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185,
    cy: 1128,
    r: 12
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibraryMarketCover);
export default __webpack_public_path__ + "static/media/library-market-cover.aee4168e05611e4c3abe4ca1571c2c03.svg";
export { ForwardRef as ReactComponent };